// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
//  rootPath: 'https://manager-dev.digitalexamregistration.com/api/manager',
  // rootPath: 'http://localhost:8080/api/manager',
  rootPath: 'https://api.manager.digitalexamregistration.com/api/manager',
  env: 'prod'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.



  //private rootPath = 'http://localhost:8010/api/manager';